module.exports = __webpack_public_path__ + "img/myqr-logo-kbbank@3x.dc51465c.png";